/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import {
  Account,
  ProximityRight,
  Supplier,
  ProximityRole,
  ProximityRoleRightMap,
  GlobalAdmin,
  ProximityAreaEnum,
  TemplateVariable,
  NotificationQuery,
  NotificationTemplate,
  Email,
  Manufacturer,
  Guideline,
} from '@models';
import * as _ from 'lodash';
import { DbQueryService, GlobalUnitOfWork, TypedQuery } from '@data';
import { UtilFns } from '@utils';

@Injectable({ providedIn: 'root' })
export class GlobalDbQueryService extends DbQueryService {
  constructor(public override uow: GlobalUnitOfWork) {
    super(uow);
    // Make sure that you don't strand a mapping type by deleting either end but leaving it intact.  And don't add lookup types.
    this.registeredEntityTypes = [Account, Supplier, GlobalAdmin, TemplateVariable, Manufacturer];
  }

  async getGlobalAdmins() {
    return this.uow.createQuery(GlobalAdmin).expand(['proximityUser', 'proximityUser.proximityRole']).execute();
  }

  /** Every manufacturer of every supplier, for Integrations > Catalog Feeds. */
  async getManufacturersWithSupplier() {
    return this.uow.createQuery(Manufacturer).expand(['supplier']).execute();
  }

  async getGlobalAdminById(adminId: string) {
    const r = await this.uow
      .createQuery(GlobalAdmin)
      .where({ id: adminId })
      .expand(['proximityUser', 'proximityUser.proximityRole'])
      .execute();
    UtilFns.assertArrayOfOne(r);
    return r[0];
  }

  async getGlobalAdminRoles() {
    return this.uow.createQuery(ProximityRole).where({ areaId: ProximityAreaEnum.GlobalAdmin }).expand(['proximityRoleRightMaps']).execute();
  }

  //#region ProximityRights and ProximityUserRights

  async getProximityRights() {
    return this.uow.getAllOrQuery(ProximityRight);
  }
  async getProximityRoles() {
    return this.uow.getAllOrQuery(ProximityRole);
  }
  async getProximityRoleRights() {
    return this.uow.getAllOrQuery(ProximityRoleRightMap);
  }

  //#endregion

  //#region TemplateVariables and NotificationQueries

  async getTemplateVariables(): Promise<TemplateVariable[]> {
    return this.uow.createQuery(TemplateVariable).expand(['notificationQuery']).execute();
  }

  /** The AI guideline masters. A real query: guidelines are not a cached lookup. Overrides come from GuidelineOverrideSurvey. */
  async getGuidelines(): Promise<Guideline[]> {
    return this.uow.createQuery(Guideline).execute();
  }

  async getTemplateVariableById(id: string): Promise<TemplateVariable> {
    const r = await this.uow.createQuery(TemplateVariable).where({ id }).expand(['notificationQuery']).execute();
    UtilFns.assertArrayOfOne(r);
    return r[0];
  }

  async getNotificationQueries(): Promise<NotificationQuery[]> {
    return this.uow.getAllOrQuery(NotificationQuery) as Promise<NotificationQuery[]>;
  }

  //#endregion

  //#region NotificationTemplates

  /** Get global notification templates (templates with no accountId) */
  async getGlobalNotificationTemplates(): Promise<NotificationTemplate[]> {
    return this.uow.createQuery(NotificationTemplate)
      .where({ accountId: null })
      .expand(['notificationEvent', 'notificationType'])
      .execute();
  }

  //#endregion
  //#region Emails
  createEmailsQuery(): TypedQuery<Email> {
    return this.uow.createQuery(Email);
  }
  //#endregion

}
